import React from 'react';
import WorkflowSection from '../../../sections/AdminDashboard/Configuration/Workflow';

const Workflow = () => {
  return <WorkflowSection />;
};

export default Workflow;
